import { FC, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Component
import Component from "./Component";

//Actions
import { getListAddress } from "../../../../actions/shipperAction";

// Interface
import { WrapperInterface } from "./definitions";

const DeliveryMethod: FC<WrapperInterface> = ({
  continueAction
}) => {
  const [selected, setSelected] = useState("")
  const [loading, setLoading] = useState(false);

  // Handlers
  const fetchAddressList = async (callback) => {
    try {
      setLoading(true)

      await getListAddress()
        .then(res => res?.data)
        .then(res => {
          const _defaultAdrs = res?.data?.filter(adrs => adrs.is_default)
          callback && callback(res.data, _defaultAdrs[0])
        })
        .catch(err => { throw err })
        .finally(() => setLoading(false))
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when fething address list")
    }
  }

  const continueHandler = () => {
    if (selected === "dropoff") {
      continueAction("dropoff")
      return
    }

    fetchAddressList((addresses, defaultAddress) => {
      continueAction("pickup-address", addresses, defaultAddress)
    })
  }

  const setPickup = () => setSelected("pickup")
  const setDropoff = () => setSelected("dropoff")

  return (
    <Component
      loading={loading}
      selected={selected}
      setPickup={setPickup}
      setDropoff={setDropoff}
      continueHandler={continueHandler}
    />
  )
}

export default DeliveryMethod;